import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColumnType } from '../../data-table/data-table';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(TextInputComponent)]
})
export class TextInputComponent extends InputComponent implements OnInit {

  @Input() type?: ColumnType = ColumnType.TEXT;
  @Input() autocomplete: boolean = false;
  @Input() spellcheck = true;
  @Input() showWordCount: boolean = false;
  @Output() keyup: EventEmitter<void> = new EventEmitter<void>();

  constructor() { super(); }

  ngOnInit() { }

  override checkValidity() {
    super.checkValidity();
    if (this.isValid) {
      this.checkingValidity.emit(this);
    }
  }

  keyUp(evt){
    this.keyup.emit();
  }
}
